// Fase 7A/8 — Notifiche in-app + promemoria richiami.
// Un reminder ~5 min prima ("Tra 5 minuti…") e uno all'orario ("È ora di…").
// Ogni notifica scatta UNA sola volta (deduplica via ref). Browser Notification
// opzionale con permesso esplicito; se negato resta solo il toast in-app.
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { PhoneCall } from "lucide-react";
import { api } from "@/lib/api";
import { isDueNow } from "@/lib/callbacks";

const REMIND_MIN = 5;

function browserNotify(title, body) {
  try {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      new Notification(title, { body });
    }
  } catch { /* no-op */ }
}

export default function CallbackNotifier() {
  const reminded = useRef(new Set());
  const dued = useRef(new Set());

  useEffect(() => {
    if (typeof Notification !== "undefined" && Notification.permission === "default") {
      try { Notification.requestPermission(); } catch { /* no-op */ }
    }
    let alive = true;
    const check = async () => {
      try {
        const r = await api.get("/agency/callbacks?status=scheduled");
        if (!alive) return;
        const now = Date.now();
        (r.data || []).forEach((cb) => {
          const t = new Date(cb.scheduled_at).getTime();
          const who = `${cb.client?.name || "il contatto"}${cb.tenant?.name ? ` — ${cb.tenant.name}` : ""}`;
          // Reminder ~5 min prima
          if (t - REMIND_MIN * 60000 <= now && now < t && !reminded.current.has(cb.id)) {
            reminded.current.add(cb.id);
            toast(`Tra ~5 minuti devi chiamare ${who}`, { icon: <PhoneCall className="h-4 w-4" />, duration: 12000 });
            browserNotify("Promemoria richiamo", `Tra ~5 minuti: ${who}`);
          }
          // All'orario
          if (isDueNow(cb, new Date(now)) && !dued.current.has(cb.id)) {
            dued.current.add(cb.id);
            toast(`È ora di chiamare ${who}`, { icon: <PhoneCall className="h-4 w-4" />, duration: 12000 });
            browserNotify("È ora di chiamare", who);
          }
        });
      } catch { /* silenzioso */ }
    };
    check();
    const iv = setInterval(check, 45000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  return null;
}
